module.exports = __webpack_public_path__ + "img/3-10.4718f704.svg";